import React from 'react';
import Tabs, { Tab } from "@ingka/tabs";

import TabPanelItem from './TabPanelItem';

const TabItem = (props) => {

    // console.log("props in TabItem ::",props);
    const displayPopupOnClick = (props) =>{
        console.log("clickImage in  TabItem:::",props);
        props.onClick(props);
        // setModalIsOpen(true);
    }

    const tabs = (props.tabs && props.tabs.map((mainTab) =>
        <Tab
            key={mainTab.id}
            text={mainTab.title}
            tabPanelId={mainTab.tabPanelId}
        />
    ));

    const tabPanels = (props.tabPanels && props.tabPanels.map((tabPanel,i) => {
        // console.log("tabPanel in TabItem11 ::",tabPanel);
        return (
            <TabPanelItem key={i} TabPanel={tabPanel} onClick = {()=>displayPopupOnClick(props)}
            />
        );
    }));
    
    // const tabPanels = props.tabPanels.map((tabPanel) => {
    //     console.log("tabPanel in TabItem11 ::",tabPanel);
    //     return (
    //         <TabPanelItem className={props.className} TabPanel={tabPanel}
    //         />
    //     );
    // });
    
    return (
        <>
            <Tabs className={props.className} tabs={tabs} tabPanels={tabPanels} defaultActiveTab="tab_1" />
        </>
    )
}
export default TabItem;
